import { createContext, useContext, useMemo } from "react";
import type { FC, ReactNode } from "react";

export interface MDSKeyboardShortcutEvent {
  shortcut: string;
}

export type MDSKeyboardEventHandler = (event: MDSKeyboardShortcutEvent) => void;

interface MDSHotkeyContextValue {
  onKeyboardEvent?: MDSKeyboardEventHandler;
}

const MDSHotkeyContext = createContext<MDSHotkeyContextValue>({});

interface MDSHotkeyContextProviderProps {
  children: ReactNode;
  onKeyboardEvent?: MDSKeyboardEventHandler;
}

export const MDSHotkeyContextProvider: FC<MDSHotkeyContextProviderProps> = ({
  children,
  onKeyboardEvent,
}) => {
  const value = useMemo<MDSHotkeyContextValue>(() => ({ onKeyboardEvent }), [onKeyboardEvent]);

  return <MDSHotkeyContext.Provider value={value}>{children}</MDSHotkeyContext.Provider>;
};

export const useMDSHotkeyContext = (): MDSHotkeyContextValue => useContext(MDSHotkeyContext);
